import Icon from "@material-ui/core/esm/Icon";
import LinkIcon from "@material-ui/icons/esm/Link";
import React from 'react';
import { Link } from 'react-router-dom';
import { Info } from 'components/Text';
import useStyles from './ExternalLinkStyles';
export default function ExternalLink({
  children,
  link
}) {
  const {
    linkStyle,
    linkIcon
  } = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: linkStyle
  }, /*#__PURE__*/React.createElement(Icon, {
    className: linkIcon
  }, /*#__PURE__*/React.createElement(LinkIcon, null)), /*#__PURE__*/React.createElement(Info, {
    isBold: true
  }, /*#__PURE__*/React.createElement(Link, {
    to: {
      pathname: link
    },
    target: "_blank",
    rel: "noopener noreferrer"
  }, children)));
}